<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Selecionar Simulação de Laudo Express:</v-card-title>
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="incluirDataSimulacaoLaudo ? headersComDataSimulacao : headersSemDataSimulacao"
            :items="items"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhuma simulação de laudo express disponível"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr @click="selecionarItem(row.item)">
                <td class="button cursor-pointer">
                  {{ row.item.id }}
                </td>
                <td class="button cursor-pointer">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="text-truncate" v-bind="attrs" v-on="on">
                        {{ row.item.titulo }}
                      </div>
                    </template>
                    <span>{{ row.item.titulo }}</span>
                  </v-tooltip>
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.data_base | formatToMonth }}
                </td>
                <td v-if="incluirDataSimulacaoLaudo" class="button cursor-pointer">
                  {{ row.item.data_simulacao_laudo | formatToMonth }}
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.data_processamento | parseToDateTimeBR }}
                </td>
              </tr>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getBasesValidadas()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar as simulações de laudos express</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';

  export default {
    props: {
      activated: {
        type: Boolean,
        required: true
      },
      incluirDataSimulacaoLaudo: {
        type: Boolean,
        default: false,
        required: false
      }
    },

    emits: ['update:activated', 'selected'],

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      items: [],
      loading: false,
      headersSemDataSimulacao: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Data Base AIS',
          value: 'data_base'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        }
      ],
      headersComDataSimulacao: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Data Base AIS',
          value: 'data_base'
        },
        {
          text: 'Data de Simulação',
          value: 'data_simulacao_laudo'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        }
      ]
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    created() {
      this.getBasesValidadas();
    },

    methods: {
      getBasesValidadas() {
        this.loading = true;

        SimulacoesLaudosIncrementaisService.getByStatus('SUCESSO')
          .then((response) => (this.items = response.data.data))
          .catch(() => this.$toast.error('Erro ao recuperar as simulações de laudos express.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },

      selecionarItem(item) {
        const data = {
          id: item.id,
          titulo: item.titulo,
          data_base: this.getOnlyDateIgnoringTimestamp(item.data_base),
          data_simulacao_laudo: this.getOnlyDateIgnoringTimestamp(item.data_simulacao_laudo)
        };

        this.$emit('selected', data);

        setTimeout(() => {
          this.search = '';
        }, 500);
      },

      getOnlyDateIgnoringTimestamp(date) {
        if (date && date.length > 10) date = date.substr(0, 10);

        return date;
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      }
    }
  };
</script>

<style>
  .b-valid-label {
    color: #003a63;
    font-weight: 400;
  }
</style>
